<template>
  <div class="form-field form-image-field">
    <div class="img-container">
      <img
        :src="croppedImage"
        class="cropped-image"
        ref="cropped_img"
        :alt="_T('Cropped Image')"
      />
      <div class="change-hover">
        <button type="button" class="btn" @click="selectFile">
          {{ _T('Change photo') }}
        </button>
      </div>
    </div>
    <input
      style="display: none"
      id="fileUploader"
      type="file"
      accept="image/*"
      @change.prevent="changeImg"
      ref="file_upload"
    />

    <textarea
      style="display: none"
      v-model="image_model"
      :name="field_id"
    ></textarea>

    <b-modal
      id="cropper_modal"
      :title="modal_title"
      centered
      no-close-on-backdrop
    >
      <div class="uploader-body">
        <vue-cropper
          ref="cropper"
          :autoCrop="true"
          :src="selected_img"
          :aspectRatio="aspectRatio"
          alt="Source Image"
          :view-mode="3"
          drag-mode="crop"
          :scalable="true"
          :rotatable="false"
          :min-container-width="180"
          :min-container-height="160"
          :zoomOnTouch="false"
          :zoomOnWheel="false"
          :cropBoxMovable="true"
          :cropBoxResizable="true"
        ></vue-cropper>
      </div>
      <div slot="modal-footer">
        <b-btn
          class="cancel-button"
          @click.prevent="processCancel"
          variant="danger"
        >
          {{ _T('Cancel') }}
        </b-btn>
        <b-btn v-if="isCropping" class="ml-3" variant="primary">
          <b-spinner small label="Small Spinner"></b-spinner>
          {{ _T('Croping') }}...
        </b-btn>
        <b-btn v-else @click.prevent="cropImage" class="ml-3" variant="primary">
          {{ _T('Crop') }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'

import 'babel-polyfill'
import { mapGetters } from 'vuex'

export default {
  name: 'FormImgField',
  props: ['avatar_url'],
  data() {
    return {
      selected_img: '',
      shown: this.check_if_image_exists(),
      croppedImage: this.image_link(),
      min_width: 100,
      min_height: 100,
      image_model: '',
      field_id: 'image_id',
      isCropping: false,
    }
  },

  computed: {
    aspectRatio() {
      var width = this.min_width
      var height = this.min_height
      return parseFloat(parseFloat(width / height).toFixed(2))
    },
    ...mapGetters(['_T', 'web_user']),
    modal_title() {
      return this._T('Please Resize and Crop the Image')
    },
  },
  watch: {
    image_model() {
      this.update_parent_avatar()
    },
  },
  components: {
    VueCropper,
  },
  methods: {
    update_parent_avatar() {
      this.$emit('setImageData', this.image_model)
    },
    processCancel() {
      this.$bvModal.hide('cropper_modal')
      this.selected_img = ''
      this.$refs.file_upload.value = ''
    },
    image_link() {
      if (this.image_model) {
        return this.image_model
      } else return this.avatar_url
    },
    check_if_image_exists() {
      if (this.image_model) {
        return true
      } else return ''
    },
    clear() {
      this.image_model = ''
      this.selected_img = ''
      this.$refs.file_upload.value = ''
      this.shown = false
    },

    cropImage() {
      this.isCropping = true
      var width = this.min_width
      var height = this.min_height
      this.croppedImage = this.$refs.cropper
        .getCroppedCanvas({
          width: width,
          height: height,
          imageSmoothingQuality: 'medium',
        })
        .toDataURL('image/jpeg')
      this.shown = true

      if (this.croppedImage.startsWith('data:image')) {
        this.image_model = this.croppedImage
        // this.uploadImage()
      }
      setTimeout(() => {
        this.isCropping = false
        this.$bvModal.hide('cropper_modal')
      }, 1500)
    },
    selectFile() {
      this.$refs.file_upload.click()
    },
    uploadImage() {
      if (this.image_model) {
        this.$store.dispatch('update_user_avatar', { avatar: this.image_model })
      }
    },
    changeImg() {
      var reader = new FileReader()
      var that = this
      reader.onload = () => {
        that.selected_img = reader.result
        this.$bvModal.show('cropper_modal')
        // that.$refs.cropper.replace(that.selected_img);
      }
      var res = reader.readAsDataURL(this.$refs.file_upload.files[0])
      return res
    },
  },
}
</script>
<style lang="scss">
.cropped-image {
  border: $px1 solid $light-border;
  @media (max-width: 575px) {
    border-radius: 50%;
  }
}
</style>
